import { render, staticRenderFns } from "./GoogleDriveBackup.vue?vue&type=template&id=7fa0cfee&scoped=true&"
import script from "./GoogleDriveBackup.vue?vue&type=script&lang=js&"
export * from "./GoogleDriveBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa0cfee",
  null
  
)

export default component.exports